import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import useUserInfo from './useTtsUser';

const useRedirectInvalidPaths = () => {
  const history = useHistory();
  const location = useLocation();
  const { ttsUser } = useUserInfo();

  const checkHasEverHadCommunityVoice = async () => {
    const hasAccess = ttsUser?.hasEverHadCommunityVoice;
    if (hasAccess) return;
    history.push(ROUTES.HOME);
  };

  useEffect(() => {
    if (location.pathname.includes(ROUTES.EARNINGS_MANAGEMENT) && ttsUser?.id)
      checkHasEverHadCommunityVoice();

    // TODO: Check other paths
  }, [location.pathname, ttsUser?.id]);
};

export default useRedirectInvalidPaths;
